import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'call',
  standalone: true,
})
export class CallPipe implements PipeTransform {
  // eslint-disable-next-line class-methods-use-this
  transform<R, TArgs extends unknown[]>(transformer: (...args: TArgs) => R, ...extraArgs: TArgs): R {
    return transformer(...extraArgs);
  }
}
